<template>
  <div id="app">
    <div :class="{'admin': isAdmin, 'frontend': !isAdmin }">
      <div id="nav">
        <Nav v-if="!isAdmin" />
      </div>
      <router-view />
      <Footer v-if="!isAdmin" />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import firebase from "firebase";

export default {
  components: {
    Nav: Nav,
    Footer: Footer
  },
  created() {
    if (this.$route.path.indexOf("admin") > -1) {
      firebase.auth().onAuthStateChanged(user => {        
        if (user) {
          this.$store.dispatch('updateUserState', user);
          } else {
          // No user is signed in.
          this.$router.replace({ name: "Login" });
        }
      });
    }
  },
   computed: {
     isAdmin() {
       return this.$route.path.indexOf("admin") > -1
     }
   }
};
</script>

<style lang="scss">
@import "@/assets/style/site.scss";
body,
html,
#app {
  width: 100% !important;
}
</style>
